import TextField from "@mui/material/TextField";
import AddItemDialog from "../../Dialogs/AddItemDialog";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../..";
import { createErrorText } from "../Functions";

const ExamExistsDialog = ({
  open,
  moveAndRenameExam,
  handleCancel,
  targetPathString,
}: {
  open: boolean;
  moveAndRenameExam: (targetPath: string, newName: string) => void;
  handleCancel: () => void;
  targetPathString: string;
}) => {
  const [name, setName] = useState("");
  const paths = useSelector((state: RootState) => state.examOverview.paths);
  const [errorText, setErrorText] = useState<string | null>(null);
  const selectedRow = useSelector((state: RootState) => state.examOverview.selectedRow);
  const itemName = selectedRow?.name;

  const resetFields = () => {
    if (!open) {
      setName("");
    } else if (itemName) {
      setName(itemName);
    }
  };

  const handleConfirm = (name: string) => {
    moveAndRenameExam(targetPathString, name);
  };

  useEffect(() => {
    resetFields();
  }, [open]);

  useEffect(() => {
    setErrorText(createErrorText(paths, targetPathString, name));
  }, [name]);

  return (
    <AddItemDialog
      open={open}
      handleCancel={() => handleCancel()}
      handleConfirm={() => handleConfirm(name)}
      title={"Prüfung existiert bereits"}
      description={"Eine Prüfung mit diesem Namen existiert bereits im Zielordner. Bitte ändere den Namen."}
      confirmText={"OK"}
      confirmAllowed={errorText === null}
    >
      <TextField
        margin="dense"
        id="name"
        label="Name"
        required
        error={errorText !== null}
        style={{ width: 330 }}
        autoFocus
        value={name}
        onChange={(e) => {
          setName(e.target.value);
        }}
        onKeyDown={(e) => {
          if (e.code === "Enter" && errorText === null) {
            handleConfirm(name);
          }
        }}
        helperText={errorText ?? errorText}
      />
    </AddItemDialog>
  );
};

export default ExamExistsDialog;
